import { render, staticRenderFns } from "./EditSelectedDigiBoard.vue?vue&type=template&id=0c58fb45&scoped=true"
import script from "./EditSelectedDigiBoard.vue?vue&type=script&lang=js"
export * from "./EditSelectedDigiBoard.vue?vue&type=script&lang=js"
import style0 from "./EditSelectedDigiBoard.vue?vue&type=style&index=0&id=0c58fb45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58fb45",
  null
  
)

export default component.exports